import { Box, Button, Tooltip, Typography } from '@mui/material';
import React, { FC } from 'react';
import { HomePageControlItem } from 'modules/home/interfaces';
import { useStyles } from './ControlItem.styles';

interface ControlItemProps {
  item: HomePageControlItem;
}

export const ControlItem: FC<ControlItemProps> = ({ item }) => {
  const { classes } = useStyles();

  if (!item) {
    return null;
  }

  return (
    <Box className={classes.root}>
      <Box className={classes.icon}>
        <img src={item.icon} alt={item.title} />
      </Box>
      <Box>
        <Typography className={classes.title}>{item.title}</Typography>
        <Tooltip title={item.description}>
          <Typography className={classes.description}>{item.description}</Typography>
        </Tooltip>
      </Box>
      <Box>
        <Button
          variant="outlined"
          color="primary"
          onClick={item.action}
          disabled={item.disabled}
          className={classes.button}
        >
          {item.actionTitle}
        </Button>
      </Box>
    </Box>
  );
};
